import { Injectable } from '@angular/core';
import { ShopSettings } from '../../booking/models/shop-settings';
import { ShopSettingsService } from './shop-settings.service';
import { Observable, of } from '../../../../../node_modules/rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShopSettingsInMemoryService extends ShopSettingsService {

  constructor() {
    super();
  }

  initialize(): Observable<boolean> {
    return of(true);
  }

  get shopSettings(): ShopSettings {
      return new ShopSettings(
        20,
        25,
        120,
        60,
        true,
        15,
        15,
        60,
        0,
        18,
        'Erwachsene, Felnőtt',
        'Kinder, Gyermek',
        2,
        4
      );
  }
}
